module.exports = __webpack_public_path__ + "0f021a4ec5e718d906e0f883031d9747.png";